export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-8 max-w-[1280px] mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-400 bg-primary-500/10 rounded-full mb-4">
            联系互动
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            意见反馈与内容投稿
          </h2>
          <p className="mt-4 text-foreground-500 text-sm md:text-base leading-relaxed">
            天堂影院持续优化观影体验，欢迎您提出宝贵建议。如果您有优质影视资源推荐或内容投稿需求，
            也欢迎通过以下方式与我们取得联系。您的每一条反馈都是我们进步的动力。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="mailto:feedback@tiantangcinema.com"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm transition-all duration-200 whitespace-nowrap"
            >
              <i className="ri-mail-send-line text-base"></i>
              发送邮件反馈
            </a>
            <a
              href="#hero"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-300/60 hover:border-primary-500/50 text-foreground-600 hover:text-primary-400 font-medium text-sm transition-all duration-200 whitespace-nowrap"
            >
              <i className="ri-message-2-line text-base"></i>
              内容投稿入口
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}